import axios from "axios";
import store from "../store";
import ElementUI, { Message } from "element-ui";
import Vue from "vue";
Vue.use(ElementUI);

// 创建axios实例

const request = axios.create({
  baseURL: "/", //import.meta.env.VITE_REQUEST_BASE_URL as string,
  timeout: 20000,
});

/**
 * @desc: 异常拦截处理器
 * @param { Object } error 错误信息
 */

/**
 * @desc: 请求发送前拦截
 * @param { Object } config 配置参数
 */
request.interceptors.request.use(
  (config) => {
    config.headers = {
      Authorization: store.state.token || localStorage.getItem("token") || "",
      errorHandle: true,
      ...config.headers,
    };
    const notNeedk2approvalUrls = ["/api/v1/screen/getApproveUrl"];
    const urlIndex = notNeedk2approvalUrls.findIndex(item => config.url.includes(item));
    if(store.state.spflag && urlIndex == -1){
      config.headers.k2Approval = "ApprovalALL";
    }
    if(config.url == "/vkcms/api/h5/story/detail"){
      console.log("headers：",config.url,config.headers)
    }
    return config;
  },
  (error) => {
    return Promise.reject(error || "服务器异常");
  }
);

/**
 * @desc: 服务端响应后拦截
 * @param { Object } response 返回的数据
 */
request.interceptors.response.use(response => {
  if (response.data.code == 0 || response.data.code == 200  || response?.config?.responseType=='blob') {
    return response.data
  } else {
    if (response?.config?.headers?.errorHandle && response.data.code != 1000029) {
      const messageDesc = response?.data?.message || response?.data?.errMsg || response?.data?.msg;
      messageDesc && Message.error(messageDesc);
    }
    if (response.data.code == 410) {
      location.href = process.env.VUE_APP_USER_URL + "/gateway-front/#/login";
    }
    return Promise.reject(response.data)
  }
}, (error) => {
  if (error?.config?.headers?.errorHandle) {
    Message.error("您的网络发生异常，无法连接服务器");
  }
  return Promise.reject(error)
});

export default request;
